enum CraftsmanType {
  Cobbler = 'Cobbler',
  Cutter = 'Cutter',
  Goldsmith = 'Goldsmith',
  Designer = 'Designer',
}

export { CraftsmanType };
